// extracted by mini-css-extract-plugin
export default {"root":"_J2AdvA6M7"};